<template>
    <button @click="favorite(productId)" class="favorite btn-anime ui  default icon button " 
        :class="{'p-1 m-0 circular': type ==1, 'circular' : type ==2, 'py-md-2 shadow py-2': type == 3}">
        <i class="icon-custom-heart tinyfavorite" :class="{'ui text large icon-custom-heart tiny d-block p-1': type == 3}"></i>
        <div class="anime-cart favorite">
            <span class="s1 favorite"></span>
            <span class="s2 favorite"></span>
            <span class="s3 favorite"></span>
            <span class="s4 favorite"></span>
            <span class="s5 favorite"></span>
            <span class="s6 favorite"></span>
            <span class="s7 favorite"></span>
            <span class="s8 favorite"></span>
        </div>
    </button>
    
</template>

<script>
export default {
    name: 'addFavorite',
    components: {},
    props: {
        productId: 0,
        type: {
            type: Number,
            default: 1,
        }
    },
    data () {
        return {}
    },
    computed: {},
    created () {},
    mounted(){
        $('.btn-anime').on('click',function(){
            $(this).addClass('show-anime')
            setTimeout(function() {
                $('.btn-anime').removeClass("show-anime")
            }, 350); 
        }) 
    },
    methods: {
        favorite(id){
            this.$http
            .post('favorite',{'productId':id})
            .then(response => {
            })
            .catch(error => console.log(error))
            .finally(() => this.loading = false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .btn-anime {
        position: relative;
        
    }
    .anime-cart{
        z-index: 200;
        position: absolute;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        span{
            position: absolute;
            top: 50%;
            left: 50%;
            opacity: 0;
        }
        span::before{
            position: absolute;
            content: '';
            border: 2px solid; 
            border-color: red;
            top: -3px;
            left: -3px;
            width: 2px;
            border-radius: 10px;
        }
    }
    .show-anime .anime-cart{
        span{
            transition: all 0.35s ease-in-out;   
             animation: myshow .35s ease-in;
        }
        .s1{
            top: -50%;
        }
        .s2{
            top: 150%;
        }
        .s3{
            left: -50%;
        }
        .s4{
            left: 150%;
        }
        .s5{
            left: -25%;
            top: -25%;
        }
        .s6{
            left: -25%;
            top: 125%;
        }
        .s7{
            left: 125%;
            top: 125%;
        }
        .s8{
            top: -25%;
            left: 125%;
        }
    }
    @keyframes myshow {
        0% {opacity: 0;}
        60% {opacity: 1;}
        100% {opacity: 0;}
    }
</style>